<template>
  <div v-if="engraving" class="product-rengraving-banner">
    <h6 class="product-rengraving-banner__title">
      <span>{{ messages.engraving }}</span>
    </h6>
    <div class="product-rengraving-banner-props">
      <p v-for="(item, key) in engravingList" :key="key" class="rengraving-banner-prop">
        <span> {{ item.split(' - ')[0] }}: </span>
        <span :class="{ 'grav-text': key === 0 }"> {{ item.split('-')[1] }} </span>
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from '@/store';

const { state } = useStore();
const engraving = window.sessionStorage.getItem('engraving');
const messages = computed(() => state.results.messages);

const engravingList = engraving?.split(',');
</script>

<style lang="scss" scoped>
.product-rengraving-banner {
  grid-column: 1 / -1;
  padding: 12px 16px;
  background-color: #f7f2ec;
  &__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    margin-bottom: 8px;
  }
}
.rengraving-banner-prop {
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  span:first-child {
    color: #3f3f44;
    margin-right: 4px;
  }
  .grav-text {
    font-family: 'Great Vibes';
    font-size: 14px;
    font-weight: 400;
    line-height: 125%;
  }
}
.product-rengraving-banner-props {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 4px 24px;
}
</style>
